import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonGroup } from "react-bootstrap";
import { formatCustomDateText } from '../../utils/time';
import { CustomDateRangeSelector } from '../filters/CustomDateRangeSelector';

/**
 * Selector for the date range
 */
export const FilterTimeSelector = ({
    filterDateOptions,
    setFilterDateOptions,
    filterDateSelectorShow,
    setFilterDateSelectorShow,
    placeholderText,
    maxRangeInDays,
}: any) => {

    return (
        <ButtonGroup size="sm">
            <div>
                <Button
                    size="sm" 
                    variant={filterDateOptions.absoluteStart ? "secondary" : "outline-secondary"}
                    onClick={() => {
                        setFilterDateSelectorShow(true)
                    }}
                >
                    {filterDateOptions.absoluteStart ? formatCustomDateText(filterDateOptions) : placeholderText}<FontAwesomeIcon className="ml-1" icon={faCaretDown} style={{marginLeft: '12px'}} />
                </Button>
                {filterDateSelectorShow && (
                    <CustomDateRangeSelector
                        setShow={setFilterDateSelectorShow}
                        filterDateOptions={filterDateOptions}
                        setFilterDateOptions={setFilterDateOptions}
                        maxRangeInDays={maxRangeInDays}
                    />
                )}
            </div>
        </ButtonGroup>
    );
};

